import {Box, DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {theme} from "../../themes/theme";
import CloseIcon from "@mui/icons-material/Close";

interface ICustomCloseModal {
    onClickClose: () => void;
    title: string;
    close?: boolean;
}

export const CustomCloseModal = ({onClickClose, title, close = false}: ICustomCloseModal) => {
    return (
        <DialogTitle sx={{display: "flex"}}>
            <Box sx={{display: "flex", flexGrow: 1, borderBottom: "1px solid"}}>
                <Box sx={{
                    fontSize: "1rem",
                    color: theme.palette.common.black,
                    fontWeight: theme.typography.fontWeightLight,
                    alignItems: "center",
                    display: "flex",
                }}>
                    {title}
                </Box>
                <Box sx={{
                    flexGrow: 1,
                    justifyContent: "flex-end",
                    display: "flex"
                }}>
                    {close===true &&
                        <IconButton onClick={onClickClose}>
                            <CloseIcon sx={{color: theme.palette.common.black, fontSize: "1.2rem"}}/>
                        </IconButton>
                    }
                </Box>
            </Box>
        </DialogTitle>
    );
};